//请自行添加语言资源
const driver = {

  msg:{

  }
};
export default driver



// WEBPACK FOOTER //
// ./src/page/md/driver/lang/driver.zh.js